import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

// Store.
import { AppDispatch, AppState } from 'store';

export const useAppDispatch = (): ThunkDispatch<AppState, null, AnyAction> =>
  useDispatch<AppDispatch>();
